import { useState, useCallback } from "react";
import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../../../firebase";

interface Request {
  userId: string;
}

interface Response {}

export const useDeleteUser = () => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const deleteUser = useCallback(async (userId: string) => {
    setIsDeleting(true);
    setError(null);

    const functions = getFirebaseFunctions();

    try {
      const deleteUserFunction = httpsCallable<Request, Response>(
        functions,
        "admin_deleteUser",
      );

      await deleteUserFunction({ userId });
      setIsDeleting(false);

      return {
        success: true,
      };
    } catch (error: unknown) {
      console.error("ユーザー削除エラー:", error);
      const errorMessage = error instanceof Error ? error : new Error("ユーザーの削除に失敗しました");
      setError(errorMessage);
      setIsDeleting(false);

      return {
        success: false,
      };
    }
  }, []);

  return { deleteUser, isDeleting, error };
};
